import { HttpClient, HttpErrorResponse, HttpEvent, HttpHandler, HttpHeaders, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EMPTY, empty, NEVER, Observable, throwError } from 'rxjs';
import { catchError, concatMap, exhaustMap, finalize, mergeMap, switchMap } from 'rxjs/operators';
import { enumPerfilAcceso, globalConf } from 'src/GlobalConf';
import { VariablesGlobalesService } from '../variables-globales.service';
import * as moment from 'moment';
import { EncriptarService } from '../encriptar.service';
import { TranslateService } from '@ngx-translate/core';
import { PeticionPendiente } from 'src/app/Models/PeticionPendiente';

@Injectable({
  providedIn: 'root'
})
export class InterceptorService {
  private variables = inject(VariablesGlobalesService);
  private http = inject(HttpClient);
  encriptar = inject(EncriptarService);
  translate = inject(TranslateService);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);


  constructor() { }

  /**
   * Intercepta las peticiones HTTP
   * @param req Petición interceptada
   * @param next Devuleve la respuesta que proporciona el servidor
   */
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {


    // Comprobar si la URL es la específica para añadir solo la cabecera apikey
    if (req.url.includes("https://europe-west2-alo-suite.cloudfunctions.net")) {
      const authReq = req.clone({
        headers: req.headers.set('apikey', 'AIzaSyAxmPTAuVhtvWPVboVa9hIsBfIbLM9zGUU')
      });

      return next.handle(authReq).pipe(
        catchError((err: HttpErrorResponse) => {
          console.error("intercept", err.message);
          return throwError(err.message);
        }),
        finalize(() => {
          console.log("Peticion " + req.url + " Finalizada");

          setTimeout(async () => {
          }, 300);
        })
      );
    } else
      // INTERCEPTA LA PETICION QUE COINCIDE CON ESTA URL
      if (
        req.url.includes('api/v2/erp') ||
        req.url.includes('/parametros?grupos=ASPECTO') ||
        req.url.includes('/api/v2/auditoriaaplicaciones') ||
        req.url.includes('/api/Parametros/') ||
        req.url.includes('api/v2/administracion') ||
        req.url.includes('api/v2/documentos')
      ) {
        //console.log('Entro interceptor');

        if (this.variables.conInternet) { // COMPROBACION DE INTERNET PARA HACER PROCESO OFFLINE

          if (this.tokenValido()) {
            let guidEmpresa = this.variables.empresaActual.GUID_Registro;
            // CLONA LA REQUEST Y LE AÑADE LAS CABECERAS QUE DETERMINES
            const authReq = req.clone({
              headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.variables.usuarioActual.tokenLogin.access_token,
              }),
              body: JSON.stringify(req.body),

              // PARA AÑADIR A LA URL EL GUID DE EMPRESA
              //url: req.url + guidEmpresa,
            });
            //console.log('authReq: ',authReq);



            // DEVUELVE LA RESPUESTA A SU CAUCE
            return next.handle(authReq).pipe(

              // CONTROLA EL POSIBLE ERROR QUE VENGA EN LA PETICION
              catchError((err: HttpErrorResponse) => {
                console.error("intercept", err.message);

                return throwError(err.message);
              }),
              // CONTROLA QUE LA PETICION HA ACABADO
              finalize(async () => {
                console.log("Peticion " + req.url + " Finalizada");

                setTimeout(async () => {
                }, 300);
                // await this.loadingCtrl.dismiss();

              })
            )

          } else {
            console.log('PROCESO ACTUALIZACIÓN TOKEN');

            // Comprobamos también si hay una versión nueva disponible
            // this.swUpdate.checkForUpdate().then(() => console.log('Comprobada version PWA al actualizar token'));

            let body: string;
            let headers: any = {
              "Content-Type": "application/json" // Valor por defecto
            };

            // Comprobamos si el perfil de acceso es de empresa
            if (this.variables.perfilAcceso == enumPerfilAcceso.EMPRESA) {
              // Si es empresa, cambiamos el cuerpo y las cabeceras para hacer la petición
              body = 'grant_type=password&username=' + this.variables.empresaActual.GUID_Empresa + '&password=Ej69Tm9qmHYLWTaf&scope=empresa';
              headers['Content-Type'] = 'application/x-www-form-urlencoded';
            } else {
              // Si no es empresa, seguimos con el cuerpo y las cabeceras normales
              body = 'grant_type=password&username=' + this.variables.usuarioActual.usuario + '&password=' + this.variables.usuarioActual.password;
            }

            // Realizamos el POST dependiendo del tipo de perfil
            return this.http.post(globalConf.url_api_erp + globalConf.path_Token, body, { headers })
              .pipe(
                concatMap((tokenInfo: any) => {
                  // Actualizamos la información del token
                  this.variables.usuarioActual.tokenLogin = {
                    access_token: tokenInfo.access_token,
                    token_type: tokenInfo.token_type,
                    expires_in: tokenInfo.expires_in,
                    userName: tokenInfo.userName,
                    scope: tokenInfo.scope,
                    issued: tokenInfo['.issued'],
                    expires: tokenInfo['.expires'],
                    userId: tokenInfo.userId
                  };

                  // Clonamos la request y añadimos las cabeceras necesarias
                  let guidEmpresa = this.variables.empresaActual.GUID_Registro;
                  const authReq = req.clone({
                    headers: new HttpHeaders({
                      'Content-Type': 'application/json',
                      'Authorization': 'Bearer ' + tokenInfo.access_token
                    }),
                    body: JSON.stringify(req.body),
                    // Añadimos el GUID de empresa a la URL
                    url: req.url + guidEmpresa,
                  });

                  // Devolvemos la respuesta procesada
                  return next.handle(authReq).pipe(
                    // Controlamos los errores de la petición
                    catchError((err: HttpErrorResponse) => {
                      console.error("intercept", err.message);
                      return throwError(err.message);
                    }),
                    // Finalizamos la petición
                    finalize(async () => {
                      // Puedes ejecutar cualquier lógica de limpieza aquí
                      setTimeout(async () => { }, 300);
                    })
                  );
                })
              );

          }
        } else {
          if (req.method == "POST" || req.method == "PUT" || req.method == "DELETE" || req.method == "PATCH") {

            let msg = null;
            if (req.url.includes('vendedores') && req.method == "PUT") { this.translate.get('offline.modificarvendedor').toPromise().then((res) => { msg = res }) }
            if (req.url.includes('articulo') && req.method == "PUT") { this.translate.get('offline.modificararticulo').toPromise().then((res) => { msg = res }) }
            if (req.url.includes('clientes') && req.method == "PUT") { this.translate.get('offline.modificarcliente').toPromise().then((res) => { msg = res }) }
            if (req.url.includes('clientes') && req.method == "PATCH") { this.translate.get('offline.crearcliente').toPromise().then((res) => { msg = res }) }

            let peticionPendiente: PeticionPendiente = {
              url: req.url,
              method: req.method,
              body: req.body,
              headers: req.headers,
              message: msg,
              fecha: moment().format('DD-MM-YY HH:mm')
            }

            let peticionesPendientes: PeticionPendiente[] = [];

            this.encriptar.obtenerEnStorage('peticionesPendientes')
              .then((res) => {
                if (res) peticionesPendientes = JSON.parse(res);

                peticionesPendientes.push(peticionPendiente);

                this.variables.peticionesPendientes = peticionesPendientes;

                this.encriptar.guardarEnStorage('peticionesPendientes', JSON.stringify(peticionesPendientes))
                  .then(() => {
                    console.log("Peticion offline guardada");
                  });

              })
            return EMPTY;


          }
        }
      } else {


        if (req.url.includes("https://europe-west2-alo-suite.cloudfunctions.net")) { // Para cuando se entra por credencial, para mandar el entorno
          if (this.variables.credencialAcceso && this.variables.credencialAcceso.entorno) {
            const authReq = req.clone({
              headers: req.headers.set('entorno', this.variables.credencialAcceso.entorno)
            });

            // DEVUELVE LA RESPUESTA A SU CAUCE
            return next.handle(authReq).pipe(
              // CONTROLA EL POSIBLE ERROR QUE VENGA EN LA PETICION
              catchError((err: HttpErrorResponse) => {
                console.error("intercept", err.message);

                return throwError(err.message);
              }),
              // CONTROLA QUE LA PETICION HA ACABADO
              finalize(async () => {
                //console.log("Peticion " + req.url + " Finalizada");

                setTimeout(async () => {
                }, 300);
                // await this.loadingCtrl.dismiss();

              })
            )
          }

        }

        // DEVUELVE LA RESPUESTA A SU CAUCE
        return next.handle(req).pipe(
          // CONTROLA EL POSIBLE ERROR QUE VENGA EN LA PETICION
          catchError((err: HttpErrorResponse) => {
            console.error("intercept", err.message);

            return throwError(err.message);
          }),
          // CONTROLA QUE LA PETICION HA ACABADO
          finalize(async () => {
            //console.log("Peticion " + req.url + " Finalizada");

            setTimeout(async () => {
            }, 300);
            // await this.loadingCtrl.dismiss();

          })
        )
      }

  }

  tokenValido() {

    // console.log('interceptor tokenValido() expires')

    //// console.log('interceptor tokenValido() expires', this.variables?.tokenLogin.expires)
    // console.log('interceptor tokenValido() ', this.variables.tokenLogin)

    if (this.variables.usuarioActual.tokenLogin) {
      // console.log('interceptor tokenValido() expires_in', this.variables.tokenLogin.expires_in)
      let fechaExpiracion = moment(this.variables.usuarioActual.tokenLogin.expires).format();
      if (moment().isBefore(moment(fechaExpiracion)) == false) {  // TOKEN INVALIDO
        return false;
      } else {
        return true;
      }


    } else {
      // console.log('interceptor tokenValido() teknlogin no existe')

      return false
    }


  }
}

